import { useState } from "react"

interface StarRatingProps {
  score: number | null
  maxScore?: number
  size?: "sm" | "md" | "lg"
  interactive?: boolean
  onRate?: (score: number) => void
}

export default function StarRating({
  score,
  maxScore = 5,
  size = "md",
  interactive = false,
  onRate,
}: StarRatingProps) {
  const [hoverValue, setHoverValue] = useState<number | null>(null)
  const [clickedValue, setClickedValue] = useState<number | null>(null)
  const sizeClass = size === "sm" ? "text-sm" : size === "lg" ? "text-2xl" : "text-lg"

  const handleClick = (value: number) => {
    onRate?.(value)
    setClickedValue(value)
    setTimeout(() => setClickedValue(null), 600)
  }

  return (
    <div
      className={`flex gap-0.5 ${sizeClass}`}
      onMouseLeave={() => interactive && setHoverValue(null)}
    >
      {Array.from({ length: maxScore }, (_, i) => {
        const value = i + 1
        const isHovered = hoverValue !== null && value <= hoverValue
        const isFilled = score !== null && value <= Math.round(score)
        const isClicked = clickedValue !== null && value <= clickedValue
        const filled = isHovered || isFilled || isClicked

        return (
          <button
            key={value}
            type="button"
            disabled={!interactive}
            onClick={() => handleClick(value)}
            onMouseEnter={() => interactive && setHoverValue(value)}
            className={`leading-none transition-all duration-150 ${
              interactive ? "hover:scale-125 cursor-pointer" : "cursor-default"
            } ${
              isClicked
                ? "text-yellow-500 scale-110"
                : isHovered
                  ? "text-yellow-300"
                  : filled
                    ? "text-yellow-400"
                    : "text-gray-300 dark:text-gray-600"
            }`}
          >
            ★
          </button>
        )
      })}
    </div>
  )
}
